import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';

export default function PurchaseBillFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const [form, setForm] = useState({
    SupplierID: '',
    BillNo: '',
    BillDate: '',
    DueDate: '',
    TotalAmount: '',
    Discount: '',
    Notes: '',
    Status: 'Pending'
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/purchase/suppliers').then(res => setSuppliers(res.data));
    if (id) {
      api.get(`/purchase/purchase-bills/${id}`).then(res => {
        setForm({
          SupplierID: res.data.SupplierID || '',
          BillNo: res.data.BillNo || '',
          BillDate: res.data.BillDate ? res.data.BillDate.slice(0, 10) : '',
          DueDate: res.data.DueDate ? res.data.DueDate.slice(0, 10) : '',
          TotalAmount: res.data.TotalAmount || '',
          Discount: res.data.Discount || '',
          Notes: res.data.Notes || '',
          Status: res.data.Status || 'Pending'
        });
      });
    }
  }, [id]);

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  // Duplicate Bill No check (for add & edit)
  const isBillNoDuplicate = async (billNo) => {
    if (!billNo) return false;
    const params = id
      ? { BillNo: billNo, excludeId: id }
      : { BillNo: billNo };
    const res = await api.get('/purchase/purchase-bills/check-duplicate', { params });
    return !!res.data.exists;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.SupplierID || !form.BillNo || !form.BillDate) {
      alert('Please fill required fields');
      return;
    }
    setLoading(true);

    // Duplicate check before add/update
    const isDup = await isBillNoDuplicate(form.BillNo);
    if (isDup) {
      alert('Bill No already exists. Please enter a unique Bill No.');
      setLoading(false);
      return;
    }

    try {
      if (id) {
        await api.put(`/purchase/purchase-bills/${id}`, form);
      } else {
        await api.post('/purchase/purchase-bills', form);
      }
      navigate('/purchase/purchase-bills');
    } catch (err) {
      alert('Error: ' + (err?.response?.data?.error || err.message));
    }
    setLoading(false);
  };

  return (
    <div className="container py-4" style={{ maxWidth: 600 }}>
      <h3 className="mb-4">{id ? 'Edit' : 'Add'} Purchase Bill</h3>
      <form onSubmit={handleSubmit} className="border rounded p-4 shadow bg-white">
        <div className="mb-3">
          <label className="form-label">Supplier<span className="text-danger">*</span></label>
          <select
            className="form-select"
            name="SupplierID"
            value={form.SupplierID}
            onChange={handleChange}
            required
          >
            <option value="">Select Supplier</option>
            {suppliers.map(s => (
              <option key={s.SupplierID} value={s.SupplierID}>
                {s.Name} ({s.GSTIN || 'No GSTIN'})
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">
            Bill No <span className="text-danger">*</span>
          </label>
          <input
            className="form-control"
            name="BillNo"
            value={form.BillNo}
            onChange={handleChange}
            required
            autoComplete="off"
            placeholder="Enter Bill No (must be unique)"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Bill Date<span className="text-danger">*</span></label>
          <input
            type="date"
            className="form-control"
            name="BillDate"
            value={form.BillDate}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Due Date</label>
          <input
            type="date"
            className="form-control"
            name="DueDate"
            value={form.DueDate}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Total Amount</label>
          <input
            className="form-control"
            name="TotalAmount"
            value={form.TotalAmount}
            onChange={handleChange}
            type="number"
            step="0.01"
            min="0"
            placeholder="(optional: will auto-calc from items)"
            readOnly
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Discount</label>
          <input
            className="form-control"
            name="Discount"
            value={form.Discount}
            onChange={handleChange}
            type="number"
            step="0.01"
            min="0"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Notes</label>
          <input
            className="form-control"
            name="Notes"
            value={form.Notes}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Status</label>
          <select
            className="form-select"
            name="Status"
            value={form.Status}
            onChange={handleChange}
          >
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
            <option value="Partial">Partial</option>
          </select>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : id ? 'Update Bill' : 'Add Bill'}
        </button>
        <button
          type="button"
          className="btn btn-secondary ms-2"
          onClick={() => navigate('/purchase/purchase-bills')}
        >
          Cancel
        </button>
      </form>
    </div>
  );
}
